<div class="container-idle">

    <div
        class="modal"
        tabindex="-1">

        <div class="modal-dialog">

            <div class="modal-content">

                <!-- HEADER -->
                <div class="modal-header">

                    <div>
                        <h4 class="modal-title mb-0">
                            Crear cliente
                        </h4>

                        <small class="text-muted">
                            Cliente consumidor final
                        </small>
                    </div>

                    <button
                        type="button"
                        class="btn-close"
                        aria-label="Cerrar"
                        [disabled]="loading"
                        (click)="cancel()">
                    </button>

                </div>


                <!-- BODY -->
                <div class="modal-body">

                    <div class="alert alert-info py-2">

                        <i class="fa fa-circle-info me-1"></i>

                        El cliente será creado automáticamente con
                        <strong>NIT CF</strong>.

                    </div>


                    <!-- NOMBRE -->
                    <div class="form-group mb-3">

                        <label
                            for="clientCfName"
                            class="form-label">

                            Nombre
                            <span class="required">*</span>

                        </label>

                        <input
                            id="clientCfName"
                            name="clientCfName"
                            type="text"
                            class="form-control"
                            [(ngModel)]="name"
                            placeholder="Ingrese el nombre del cliente"
                            maxlength="150"
                            autocomplete="off"
                            [disabled]="loading">

                    </div>


                    <!-- CELULAR -->
                    <div class="form-group mb-2">

                        <label
                            for="clientCfCellphone"
                            class="form-label">

                            Número de celular
                            <span class="required">*</span>

                        </label>

                        <input
                            id="clientCfCellphone"
                            name="clientCfCellphone"
                            type="tel"
                            class="form-control"
                            [(ngModel)]="cellphone"
                            placeholder="Ej. 55555555"
                            maxlength="20"
                            autocomplete="off"
                            [disabled]="loading"
                            (keyup.enter)="save()">

                    </div>

                </div>


                <!-- FOOTER -->
                <div class="modal-footer">

                    <button
                        type="button"
                        class="btn btn-secondary"
                        [disabled]="loading"
                        (click)="cancel()">

                        CANCELAR

                    </button>

                    <button
                        type="button"
                        class="btn btn-primary"
                        [disabled]="
                            loading ||
                            !name?.trim() ||
                            !cellphone?.trim()
                        "
                        (click)="save()">

                        <ng-container *ngIf="!loading">
                            <i class="fa fa-floppy-disk me-1"></i>
                            GUARDAR
                        </ng-container>

                        <ng-container *ngIf="loading">
                            <span
                                class="spinner-border spinner-border-sm me-2"
                                role="status">
                            </span>

                            GUARDANDO...
                        </ng-container>

                    </button>

                </div>

            </div>

        </div>

    </div>

</div>